<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <Mlogin />
            <DocumentsNewsBlockControl />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div class="title_all" style="margin-bottom: 0">
                    <div class="title_left">过刊目录</div>
                    <div class="title_more2"><a href="/">首页</a>>过刊目录</div>
                    <div class="clearfix"></div>
                  </div>
                  <dlistnumList></dlistnumList>
                </div>
              </div>
            </div>
          </el-col>
        
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import dlistnumList from '../components/dlistnumList'
export default {
  data() {
    return {}
  },
  components: {
    dlistnumList,
  },
  methods: {
    onSubmit() {},
  },
}
</script>

<style scoped></style>
